var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { CurrencyEnum } from '../../../../../models/modules/lotteryplatofrm.models';
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { LookupValueRequest, LookupValueQuery, ConfirmationDialogModel } from "../../../../../models/lookups/lookup.models";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import * as Enumerable from "linq";
import { computedFrom } from "aurelia-binding";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { LotteryPlatformClaims } from "../../../../../constants/modules/lotteryplatform.claims";
import { Guid } from "../../../../../utilities/guid";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { LotteryOperatorDialog } from "../dialogs/lottery-ticketprice-dialog";
import { RequestClient } from '../../../../../services/basics/request-client.service';
var BrandSettings = /** @class */ (function (_super) {
    __extends(BrandSettings, _super);
    function BrandSettings(notificationService, i18N, tokenClientService, lookupClientService, userClaimsService, queriesService, dialogClient, lotteryOperatorDialog, requestClient) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.tokenClientService = tokenClientService;
        _this.lookupClientService = lookupClientService;
        _this.userClaimsService = userClaimsService;
        _this.queriesService = queriesService;
        _this.dialogClient = dialogClient;
        _this.lotteryOperatorDialog = lotteryOperatorDialog;
        _this.requestClient = requestClient;
        _this.allLanguages = [];
        _this.allCurrencies = [];
        _this.showCurrencyName = "";
        _this.shouldCheckCurrency = false;
        return _this;
    }
    Object.defineProperty(BrandSettings.prototype, "isReadonly", {
        get: function () {
            return !this.item.isEditable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandSettings.prototype, "isBrandAdmin", {
        get: function () {
            return this.tokenClientService && this.tokenClientService.isBrandAdmin();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandSettings.prototype, "canEnableAgent", {
        get: function () {
            return this.userClaimsService.hasPermission(LotteryPlatformClaims.EnableAgent);
        },
        enumerable: false,
        configurable: true
    });
    BrandSettings.prototype.addUser = function () {
        this.item.brandUsers.push(this.defaultUser);
    };
    BrandSettings.prototype.isEuro = function (currency) {
        return currency.id == CurrencyEnum.Euro;
    };
    BrandSettings.prototype.addUrl = function () {
        this.item.brandUrls.push(this.defaultBrandUrl);
    };
    BrandSettings.prototype.removeUser = function (brandUserItem) {
        var _this = this;
        require("../../dialogs/delete-modal"); // this is to show delete modal dialog
        this.dialogClient.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
            delete: function () { return new Promise(function (resolve, reject) {
                resolve();
                var index = _this.item.brandUsers.indexOf(brandUserItem);
                _this.item.brandUsers.splice(index, 1);
                _this.dialogClient.hide();
            }); }
        });
    };
    BrandSettings.prototype.removeBrandUrlDelete = function (brandUrlItem) {
        var index = this.item.brandUrls.indexOf(brandUrlItem);
        this.item.brandUrls.splice(index, 1);
    };
    BrandSettings.prototype.confirmRemoveBrandUrl = function (brandUrlItem) {
        var _this = this;
        var urlValue = Object(brandUrlItem)["url"];
        if (urlValue != null) { // if url has value, then the delete dialog will show to get confirmation to delete, else it deletes instantly.
            require("../../dialogs/delete-modal"); // this is to show delete modal dialog
            this.dialogClient.show(DialogServiceConstants.URLs.DeleteModalConfirmation, {
                delete: function () { return new Promise(function (resolve, reject) {
                    resolve();
                    _this.removeBrandUrlDelete(brandUrlItem);
                    _this.dialogClient.hide();
                }); }
            });
        }
        else {
            this.removeBrandUrlDelete(brandUrlItem);
        }
    };
    BrandSettings.prototype.isCurrencyDefault = function (currency) {
        return this.item.defaultCurrencyId == currency.id;
    };
    BrandSettings.prototype.isLanguageDefault = function (language) {
        return this.item.defaultLanguageId == language.id;
    };
    BrandSettings.prototype.setLanguageAsDefault = function (event, language) {
        if (Enumerable.from(this.item.brandLanguages).any(function (x) { return x.languageId == language.id; })) {
            if (event.detail.value) {
                this.item.defaultLanguageId = language.id;
            }
        }
    };
    BrandSettings.prototype.setCurrencyAsDefault = function (event, currency) {
        if (Enumerable.from(this.item.brandCurrencies).any(function (x) { return x.currencyId == currency.id; })) {
            if (event.detail.value) {
                this.item.defaultCurrencyId = currency.id;
            }
        }
    };
    BrandSettings.prototype.isLanguageChecked = function (language) {
        return Enumerable.from(this.item.brandLanguages).any(function (x) { return x.languageId == language.id; });
    };
    BrandSettings.prototype.assignLanguage = function (event, language) {
        if (event.detail.value) {
            this.item.brandLanguages.push({ languageId: language.id, brandId: this.item.brandId });
        }
        else {
            var brandLanguage = Enumerable.from(this.item.brandLanguages).firstOrDefault(function (x) { return x.languageId == language.id; });
            var brandLanguageIndex = this.item.brandLanguages.indexOf(brandLanguage);
            this.item.brandLanguages.splice(brandLanguageIndex, 1);
        }
    };
    BrandSettings.prototype.doesTheBrandHasThisCurrency = function (currency) {
        return Enumerable.from(this.item.brandCurrencies).any(function (x) { return x.currencyId == currency.id; });
    };
    BrandSettings.prototype.validateClickEvent = function (event, currency) {
        return __awaiter(this, void 0, void 0, function () {
            var confirmModel, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(currency.id == CurrencyEnum.Euro)) return [3 /*break*/, 1];
                        return [2 /*return*/, true]; // return true for check box checked.
                    case 1:
                        if (!currency.selected) return [3 /*break*/, 3];
                        require("../../dialogs/confirmation-dialog");
                        confirmModel = new ConfirmationDialogModel();
                        confirmModel.headerTitle = "change-confirmation";
                        confirmModel.headerMessage = "currency-ticket-price-override-warning-text";
                        confirmModel.headerMessageTranslateProps = {
                            currencyName: currency.name
                        };
                        // click 'yes' from pop up to remove check box item from brand currency list
                        return [4 /*yield*/, this.dialogClient.show(DialogServiceConstants.URLs.ConfirmationDialog, {
                                confirmModel: confirmModel,
                                save: function () { return new Promise(function (resolves, reject) {
                                    var brandCurrency = Enumerable.from(_this.item.brandCurrencies).firstOrDefault(function (x) { return x.currencyId == currency.id; });
                                    var brandCurrencyIndex = _this.item.brandCurrencies.indexOf(brandCurrency);
                                    _this.item.brandCurrencies.splice(brandCurrencyIndex, 1);
                                    currency.selected = false;
                                    _this.dialogClient.hide();
                                    return false;
                                }); },
                                hide: function () { return new Promise(function () {
                                    currency.selected = true;
                                    _this.dialogClient.hide();
                                    return true;
                                }); }
                            })];
                    case 2:
                        // click 'yes' from pop up to remove check box item from brand currency list
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 3:
                        // check for subscription that already exists
                        _a = currency;
                        return [4 /*yield*/, this.checkforSubscription()];
                    case 4:
                        // check for subscription that already exists
                        _a.selected = _b.sent();
                        if (!currency.selected) return [3 /*break*/, 6];
                        this.item.ticketPriceCurrencyId = currency.id;
                        return [4 /*yield*/, this.checkGamesHasSelectedCurrency()];
                    case 5:
                        if ((_b.sent()) > 0) {
                            // check on each games has this currency for ticket price,
                            //if anyone of the game doesn't have this currency for ticket price, pop up will open with list of games.
                            currency.selected = false;
                            require("../dialogs/lottery-ticketprice-dialog");
                            this.dialogClient.show(DialogServiceConstants.URLs.LotteryTicketPriceCurrency, this.item, true, true);
                            return [2 /*return*/, false];
                        }
                        _b.label = 6;
                    case 6:
                        currency.selected = false;
                        return [2 /*return*/, true];
                    case 7: return [2 /*return*/, false];
                }
            });
        });
    };
    // call this function when validate check event return true.
    BrandSettings.prototype.assignCurrencyOnChange = function (event, currency) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (event.detail.value) {
                    if (Enumerable.from(this.item.brandCurrencies).count(function (x) { return x.currencyId == currency.id; }) == 0) {
                        this.item.brandCurrencies.push({ currencyId: currency.id, brandId: this.item.brandId });
                    }
                    currency.selected = true;
                }
                return [2 /*return*/];
            });
        });
    };
    // check for lottery/instant game/ bundle subscription
    BrandSettings.prototype.checkforSubscription = function () {
        return __awaiter(this, void 0, void 0, function () {
            var errorMessage, oDataUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        errorMessage = "";
                        oDataUrl = "/odata/Brands?brandId=".concat(this.item.brandId);
                        return [4 /*yield*/, this.queriesService.getData(oDataUrl).then(function (response) {
                                response.value.map(function (a) {
                                    if (a.lotteries == 0 && a.instantGames == 0 && a.bundles == 0) {
                                        errorMessage = "Subscribe to at least one lottery/bundle/instant game";
                                    }
                                });
                            })];
                    case 1:
                        _a.sent();
                        if (errorMessage != "") {
                            this.notificationService.show("Validation Error!", errorMessage + " and Create ticket price with this Currency.", NotificationType.Error);
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    // check  count of lotterygames/Instantgames/BundleGames which don't have ticket price with this selected currency
    BrandSettings.prototype.checkGamesHasSelectedCurrency = function () {
        return __awaiter(this, void 0, void 0, function () {
            var bundleCount, lotteryCount, instantGameCount, oDataUrl, checkgameList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bundleCount = 0;
                        lotteryCount = 0;
                        instantGameCount = 0;
                        oDataUrl = "/odata/GameListDoesNotHaveCurrencies?brandId=".concat(this.item.brandId, "&currencyId=").concat(this.item.ticketPriceCurrencyId, "&showLottery=1&showInstantGame=1&showBundle=1");
                        return [4 /*yield*/, this.queriesService.getData(oDataUrl).then(function (response) {
                                response.value.map(function (a) {
                                    a.bundleId ? bundleCount++ : 0;
                                    a.lotteryId ? lotteryCount++ : 0;
                                    a.instantGameId ? instantGameCount++ : 0;
                                });
                            })];
                    case 1:
                        _a.sent();
                        this.item.disableBundle = bundleCount == 0;
                        this.item.disableLottery = lotteryCount == 0;
                        this.item.disableInstantGame = instantGameCount == 0;
                        checkgameList = bundleCount + lotteryCount + instantGameCount;
                        return [2 /*return*/, checkgameList];
                }
            });
        });
    };
    BrandSettings.prototype.onSelectControlChanged = function (index) {
        if (Enumerable.from(this.item.brandUsers).where(function (x) { return x.userId != 0; }).groupBy(function (x) { return x.userId; }).any(function (c) { return c.count() > 1; })) {
            this.notificationService.show("Validation Error!", "This user is already assigned to this brand.", NotificationType.Error);
            if (this.item.brandUsers.length != 0) {
                this.item.brandUsers[index].userId = 0;
            }
        }
    };
    Object.defineProperty(BrandSettings.prototype, "defaultUser", {
        get: function () {
            return {
                userId: 0,
                branchId: 0,
                departmentId: 0,
                roleId: 0
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandSettings.prototype, "defaultBrandUrl", {
        get: function () {
            return {
                url: null
            };
        },
        enumerable: false,
        configurable: true
    });
    BrandSettings.prototype.generateIFrameToken = function () {
        var _this = this;
        setTimeout(function () {
            _this.item.iFrameToken = Guid.generateGuid().toString();
        });
    };
    BrandSettings.prototype.attached = function () {
        var _this = this;
        var languagePromise = this.getAllLanguages();
        var currencyPromise = this.getAllCurrencies();
        Promise.all([languagePromise, currencyPromise]).then(function () {
            if (!_this.item.brandId) {
                var euroDefault = Enumerable.from(_this.allCurrencies).firstOrDefault(function (s) { return s.id == CurrencyEnum.Euro; });
                var defaultLanguage = _this.allLanguages[0].id;
                var defaultCurrency = euroDefault ? euroDefault.id : _this.allCurrencies[0].id;
                _this.item.brandCurrencies.push({ currencyId: defaultCurrency });
                _this.item.brandLanguages.push({ languageId: defaultLanguage });
                _this.item.defaultLanguageId = defaultLanguage;
                _this.item.defaultCurrencyId = defaultCurrency;
            }
        });
    };
    BrandSettings.prototype.getAllCurrencies = function () {
        var _this = this;
        var request = new LookupValueRequest();
        var selecatbleCurrencies = [];
        request.lookupValueQuery = LookupValueQuery.currencies;
        return this.lookupClientService.getLookup(request).then(function (x) {
            if (_this.item.brandId == null || _this.item.brandId == 0) {
                // Euro currency only showing while on creating new brand to the user.
                x.values.filter(function (e) { return e.id == CurrencyEnum.Euro; }).map(function (lv) {
                    var slv = lv;
                    slv.selected = slv.id == CurrencyEnum.Euro; // by default set euro as assigned on creating new brand
                    selecatbleCurrencies.push(slv);
                });
            }
            else {
                // showing currencies which are selected as operator currencies.
                var operatorCurrencies = Enumerable.from(_this.item.operator.operatorCurrencies).select(function (x) { return x.currencyId; }).toArray();
                x.values.filter(function (x) { return operatorCurrencies.includes(x.id); }).map(function (lv) {
                    var slv = lv;
                    slv.selected = _this.doesTheBrandHasThisCurrency(slv);
                    selecatbleCurrencies.push(slv);
                });
            }
            _this.allCurrencies = selecatbleCurrencies;
        });
    };
    BrandSettings.prototype.getAllLanguages = function () {
        var _this = this;
        var request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.languages;
        return this.lookupClientService.getLookup(request).then(function (x) {
            _this.allLanguages = x.values;
        });
    };
    __decorate([
        computedFrom("item.isEditable"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BrandSettings.prototype, "isReadonly", null);
    BrandSettings = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N, TokenClient,
            LookupClientService, UserClaimsService,
            QueriesClientService, DialogClientService,
            LotteryOperatorDialog,
            RequestClient])
    ], BrandSettings);
    return BrandSettings;
}(ChildComponent));
export { BrandSettings };
